module.exports = __webpack_public_path__ + "3f16e137/img/settings-ico.a214628d.svg";